// ============================================================================
// GOLD RATE ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/masters/gold-rates';

export const goldRateEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  active: () => buildEndpoint(`${BASE_PATH}/active`),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  activate: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/activate`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
} as const;

export default goldRateEndpoints;
